import React from 'react';
import Navbar from '../components/Navbar';
import Headings from '../components/Headings';
import ContactBlock from '../components/ContactBlock';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';

const Contact = () => {
  return (
    <>
      <Navbar />
      <Headings headingName="Contact" />
      <ContactBlock />
      <ContactForm />
      <Footer />
    </>
  );
};

export default Contact;
